
import React from "react";
import Project from "../components/Project/Project";
import { projects } from "../Helpers/ProjectsList";

const Projects = () => {
    return (
        <main className="section">
                <div className="container">
                    <h2 className="title-1">Projects</h2>
                    <ul className="projects"> 
                            
                         {projects.map((project, index) => {
                            return <Project 
                            key={index}
                            title={project.title} 
                            image={project.image} 
                            index={index}
                            />
                            })}
                            
                    </ul>
                </div>
            </main>
    )
}

export default Projects;